<template>
  <div id="app">
  <google-map />
  </div>
</template>

<script>
import  GoogleMap from './components/GoogleMap.vue'

export default {
  name: 'app',
  components: {
     GoogleMap
  }
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import './assets/css/style.scss';

</style>